import type { DeliverableType } from "@/schemas";

export const RuleActionContext: Record<string, DeliverableType> = {
	Carton: "Carton",
	Label: "Label",
	Solution: "Solution",
	Dim: "Dim",
} as const;
